<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbarPages />
    </div>

    <div class="content-wrapper">
      <!-- <PageBanner pageTitle="Service Details" mainTitle="Service Details" /> -->
      <div class="service-details-wrap ptb-50">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
              <SideBar />
            </div>

            <div class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
              <div class="service-desc">
                <!-- <img src="../../../assets/images/service/diabet-nutritie-1.jpg" alt="Diabet și nutriție" /> -->

                <h2>Diabet și nutriție – echilibru, prevenție și sănătate pe termen lung</h2>
                <p>
                  Specialitatea de diabet și nutriție este dedicată evaluării și
                  monitorizării tulburărilor metabolice, precum și adoptării unui stil
                  de viață sănătos prin alimentație corectă și recomandări personalizate.
                </p>

                <!-- Echipa medicala -->
                <div class="row">
                  <div class="col-xl-3 col-lg-4 col-md-6 aos-init aos-animate" data-aos="fade-up"
                    data-aos-duration="1200" data-aos-delay="500">
                    <a href="/echipa_medicala/claudiu_nicolaiev#echipa_medicala">
                      <div class="team-card style1">
                        <div class="team-img">
                          <img src="../../../assets/images/doctors/dr-claudiu-nicolaiev.jpg" alt="dr-nume-prenume">
                        </div>
                        <div class="team-info">
                          <span>Dr. Claudiu Nicolaiev</span> 
                          <!-- <span>Medic specialist diabetologie și nutriție</span> -->
                        </div>
                      </div>
                    </a>
                  </div>
                </div>

                <h3>Servicii</h3>
                <p>
                  În cadrul cabinetului de diabet și nutriție sunt oferite servicii
                  medicale complete, adaptate nevoilor fiecărui pacient.
                </p>

                <div class="card mb-10" v-for="service in services" :key="service.name">
                  <div class="row" style="padding: 10px 20px;">
                    <div class="card-service col-xl-10 col-lg-10 col-md-10">
                      <i class="ri-check-double-line" style="vertical-align: bottom;"></i> {{ service.name }}
                    </div>
                    <div class="service-price col-xl-2 col-lg-2 col-md-2 text-align-right">
                      <!-- {{ service.price }} Lei -->
                    </div>
                  </div>
                </div>

                <div class="other-option md-none mb-40">
                  <a href="/#appointment" class="btn style2">
                    Solicită o programare
                  </a>
                </div>

                <h3>Întrebări frecvente</h3>
                <p>
                  Mai jos găsești răspunsuri la cele mai frecvente întrebări legate de
                  consultațiile de diabet și nutriție.
                </p>

                <div class="accordion" id="accordionExample_one">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Când este recomandată o consultație de diabet și nutriție?
                      </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Consultația este recomandată în cazul diagnosticării diabetului,
                          valorilor crescute ale glicemiei, problemelor de greutate sau
                          atunci când este necesară o alimentație adaptată unei afecțiuni medicale.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Este necesară trimitere pentru consultație?
                      </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Pentru consultațiile în cadrul clinicii private, nu este necesară
                          trimitere medicală. Programarea se poate face direct.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Se primește un plan alimentar personalizat?
                      </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Da, fiecare pacient primește un plan alimentar adaptat nevoilor
                          sale medicale, stilului de viață și obiectivelor stabilite
                          împreună cu medicul.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFour">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Consultația de nutriție este potrivită și fără diabet?
                      </button>
                    </h2>
                    <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Da, consultația de nutriție este recomandată tuturor persoanelor
                          care doresc să își îmbunătățească stilul de viață, greutatea
                          corporală sau alimentația zilnică.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../../Layouts/TopHeader.vue";
import MainNavbarPages from "../../Layouts/MainNavbarPages.vue";
import SideBar from "./SideBar.vue";
// import ServiceDetails from "../../ServiceDetails/ServiceDetails.vue";
import MainFooter from "../../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "DiabetologiePage",
  components: {
    TopHeader,
    SideBar,
    MainNavbarPages,
    // ServiceDetails,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
      services: [
        {
          name: "Consultație diabetologică și nutriție",
          price: 300
        },
        {
          name: "Evaluare nutrițională completă",
          price: 200
        },
        {
          name: "Plan alimentar personalizat",
          price: 350
        },
        {
          name: "Monitorizare și ajustare plan nutrițional",
          price: 200
        }
      ]
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>